import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  FormControl,
  FormControlProps,
  FormHelperText,
} from "@mui/material";
import React from "react";

import { useFieldContext } from "src/hooks";

type Props = Pick<FormControlLabelProps, "label"> &
  Pick<CheckboxProps, "disabled"> &
  Pick<FormControlProps, "sx">;

export const CheckboxField = ({ label, disabled, sx }: Props) => {
  const field = useFieldContext<boolean>();

  return (
    <FormControl error={field.state.meta.errors.length > 0} sx={sx}>
      <FormControlLabel
        control={
          <Checkbox
            checked={field.state.value}
            disabled={disabled}
            onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) =>
              field.handleChange(checked)
            }
          />
        }
        label={label}
        disabled={disabled}
      />
      {field.state.meta.errors.length > 0 && (
        <FormHelperText>
          {field.state.meta.errors.map((e) => e.message || e).join(", ")}
        </FormHelperText>
      )}
    </FormControl>
  );
};
